export default __webpack_public_path__ + "static/media/empty.df4eb355.png";